import { ButtonV2 } from '@findy-code/yuffie/ui/button';
import { FaEdit, FaEnvelope } from 'react-icons/fa';
import ReactPlayer from 'react-player';

import {
  LegacyModal,
  LegacyModalBody,
  LegacyModalBodyContent,
  LegacyModalCloseButton,
  LegacyModalContent,
  LegacyModalDescription,
  LegacyModalMainTitle,
} from './legacy-modal';
import styles from './match-modal.component.module.scss';

type Props = {
  isOpen: boolean;
  companyName: string;
  matchHash: string;
  hasVision: boolean;
  hasLatestDevelopmentResults: boolean;
  onClose?: () => void;
};

export const MatchModal = ({
  isOpen,
  companyName,
  matchHash,
  hasVision,
  hasLatestDevelopmentResults,
  onClose,
}: Props) => {
  const description =
    hasVision && hasLatestDevelopmentResults
      ? '気軽にメッセージを送ってみましょう！'
      : `プロフィール「${
          !hasVision ? 'この先やってみたいこと' : '直近の開発実績'
        }」を入力してあなたの魅力を企業に伝えてみましょう。 プロフィール内容を充実させることで企業からのメッセージが届きやすくなります。`;

  const linkUrl =
    hasVision && hasLatestDevelopmentResults
      ? `/matches/${matchHash}`
      : `/settings/profile${
          !hasVision ? '#vision' : '#latest_development_results'
        }`;

  const buttonText =
    hasVision && hasLatestDevelopmentResults
      ? 'メッセージを送る'
      : 'プロフィールを編集する';

  return (
    <LegacyModal
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
      onClose={onClose}
    >
      <LegacyModalContent>
        <LegacyModalCloseButton onClose={onClose} />
        <ReactPlayer
          autoPlay
          muted
          playing
          playsinline
          class={styles.reactPlayer}
          height="100%"
          loop={false}
          url="/videos/job-description-match.mp4"
          width="100%"
        />
        <LegacyModalBody className={styles.legacyModalBody}>
          <LegacyModalMainTitle>{`${companyName}とマッチしました！`}</LegacyModalMainTitle>
          <LegacyModalBodyContent>
            <LegacyModalDescription text={description} />
          </LegacyModalBodyContent>
          <LegacyModalBodyContent>
            <div className={styles.buttonWrap}>
              <ButtonV2
                as="a"
                href={linkUrl}
                startIcon={
                  hasVision && hasLatestDevelopmentResults ? FaEnvelope : FaEdit
                }
                variant="primary"
              >
                {buttonText}
              </ButtonV2>
            </div>
          </LegacyModalBodyContent>
        </LegacyModalBody>
      </LegacyModalContent>
    </LegacyModal>
  );
};
